import { Vehicle } from "system/Domain";

export const hasAllDocumentsArrived = (vehicle: Vehicle): boolean => {
	const status = vehicle.remarketing?.registrationDocuments?.status;
	return status === "Storage" || status === "Arrived" || status === "ReadyForHandOver";
};
